import React, { Component } from "react";

class SkipLinkNext extends Component {
  constructor() {
    super();

    this.state = {
      skipNextOn: false
    };

    /**
     * Event Bindings
     *
     * @method - this.handleSkipLinksOnFocus
     * @method - this.handleSkipLinksOnBlur
     */
    this.handleSkipNextOnFocus = this.handleSkipNextOnFocus.bind(this);
    this.handleSkipNextOnBlur = this.handleSkipNextOnBlur.bind(this);
  }

  /**
   * @method handleSkipNextOnBlur - hides the SkipNext link when it loses focus.
   *
   * @param {event} - onBlur event
   */
  handleSkipNextOnBlur(event) {
    if (event.type === "blur") {
      if (this.state.skipNextOn) {
        this.setState({ skipNextOn: false });
      }
    }
  }

  /**
   * @method handleSkipNextOnFocus - shows the SkipNext link when it gains focus.
   *
   * @param {event} - onFocus event
   */
  handleSkipNextOnFocus(event) {
    if (event.type === "focus") {
      if (!this.state.skipNextOn) {
        this.setState({ skipNextOn: true });
      }
    }
  }
  /**
   * Render and return the JSX SkipNextComponent.
   */
  render() {
    const skipNextContainerStatus = this.state.skipNextOn
      ? "skplink-container-content active"
      : "skplink-container-content";
    const skipNextLinkStatus = this.state.skipNextOn
      ? "skip-next skplnk-focus active"
      : "skip-next skplnk-focus";
    const inlineStyle = {
      "marginBottom": "18px"
    };
    return (
      <div id="skplinkContainer-content" className={skipNextContainerStatus}>
        <a
          className={skipNextLinkStatus}
          aria-label="Skip the course preview carousel "
          href="#courseDescription"
          sktarget="#courseDescription"
          onFocus={event => this.handleSkipNextOnFocus(event)}
          onBlur={event => this.handleSkipNextOnBlur(event)}
          style={inlineStyle}
        >
          Skip Course Preview Carousel
        </a>
      </div>
    );
  }
}

export default SkipLinkNext;
